import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

//CSS
import "./UserCard.css";
import SvgClientIcon from "../../SvgIcons/ClientIcon";

//Components
import Button from "../Other Components/button";
import PageLoader from "../Other Components/pageLoader";
import CopyableText from "../Other Components/CopyableText";

//Functions and hooks
import { GetUserInfo } from "../../BackendAccess/UserHooks";
import { fetchWithTimeout } from "../../hooks/useFetchWithTimeout";
import { useNotification } from "../../Contexts/NotificationContext";
import { useErrorHandler } from "../../hooks/errorHandler";
import { GetStorageLink } from "../../BackendAccess/FrontendHelpers";
import { useTranslation } from "react-i18next";

export default function UserCard() {
  const [username, setUsername] = useState("");
  const [ID, setID] = useState("");
  const [email, setEmail] = useState("");
  const [preview, setPreview] = useState(null);

  const [imageSrc, setImageSrc] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [pageError, setPageError] = useState(null);

  const { showNotification } = useNotification();

  useErrorHandler(error, showNotification, setPageError);

  const navigate = useNavigate();

  const { t } = useTranslation();

  useEffect(() => {
    GetUserData();
  }, []);

  const GetUserData = async () => {
    try {
      setLoading(true);
      const [data, error] = await fetchWithTimeout(GetUserInfo);

      if (error) {
        error.isPageError = true;
        setError(error);
      } else {
        await SetUserData(data);
      }
    } catch (err) {
      setError({ err: t("server.Server error."), errCode: 500 });
    } finally {
      setLoading(false);
    }
  };

  const SetUserData = async (data) => {
    const imagePath = data.ImagePath ? GetStorageLink() + data.ImagePath : null;
    setUsername(data.Username);
    setEmail(data.Email);
    setID(data.UserID);
    setPreview(imagePath);
  };

  const OnSettingsClick = () => {
    navigate("/settings/user");
  };
  const previewImage = preview ? (
    <img src={preview} alt={t("No image.")} className="input-image z-inherit" />
  ) : (
    <SvgClientIcon className="user-card-image empty" />
  );
  return (
    <div className="user-card-container">
      <PageLoader loading={loading} error={pageError}>
        <div className="user-card-image-container" onClick={OnSettingsClick}>
          {previewImage}
        </div>

        <div className="user-card-info-container">
          <div className="user-card-text-info-container">
            <CopyableText className="user-card-info username">
              {username}
            </CopyableText>
            <CopyableText className="user-card-info id">{ID}</CopyableText>
            <CopyableText className="user-card-info email">
              {email}
            </CopyableText>
          </div>
          <Button
            btnSize={"btn-small"}
            btnStyle={"btn-primary"}
            className=" shadow-small mt-1"
            icon={"cog"}
            onClick={OnSettingsClick}
          >
            {t("Settings")}
          </Button>
        </div>
      </PageLoader>
    </div>
  );
}
